import { defineRecipe } from '@plurall/elo-v3';

export const essaysHeaderYearRecipe = defineRecipe({
  className: 'essays-header__year',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'space.8',
    minWidth: '175px',
    '& > span': {
      color: 'text.secondary',
      fontSize: 'font-size-small',
      fontWeight: 'font.weight.semi.bold',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    },
  },
});
